export default {
    Bills: 'الفاتورة|الفواتير',
};
